let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6D08s")).then(() => parcelRequire('l6rHB'));